import React, {useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadAdminAuthData, loadUserAuthData } from '../../action/auth_action';
import { isAuthenticated, getUserData ,getAdminData } from '../../util/util';

export const AuthGuardImpl = ({ component: Template, ...rest }) => {
  loadUserAuthData();

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

AuthGuardImpl.defaultProps = {
  location: {}
};

AuthGuardImpl.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};

export const PublicRoute = ({ component: Template, ...rest }) => {

  const userInfo = getUserData();
  let redirectUrl = '';
  if (userInfo) {
      redirectUrl = '/payment';  
  }
  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated() ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectUrl,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

PublicRoute.defaultProps = {
  location: {}
};

PublicRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};

export const AuthAdmin = ({ component: Template, ...rest }) => {

  loadAdminAuthData();
  const adminInfo = getAdminData();
  let redirectUrl = '';
  if (adminInfo) {
      redirectUrl = 'campaign';  
  }
  return (
    <Route
      {...rest}
      render={props =>
        adminInfo ? (
          <Template {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/admin/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};
AuthAdmin.defaultProps = {
  location: {}
};

AuthAdmin.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.object
};




// WEBPACK FOOTER //
// ./web/components/common/AuthGaurd.js